import { useEffect } from 'react';

interface StructuredDataProps {
  /** One or more Schema.org JSON-LD objects */
  schemas: object[];
  /** Unique id suffix so multiple instances don't clash */
  id: string;
}

/**
 * Injects JSON-LD structured data into <head> and cleans up on unmount.
 * Works in a React SPA without react-helmet.
 */
const StructuredData = ({ schemas, id }: StructuredDataProps) => {
  useEffect(() => {
    const scriptId = `jsonld-${id}`;
    // Remove any existing script with this id first
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(
      schemas.length === 1 ? schemas[0] : schemas,
      null,
      2
    );
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [schemas, id]);

  return null;
};

export default StructuredData;
